import { getCart, getCartCount, addCart, addCartByTransaction, updateCart } from "./utils"

class HttpDataClient {

  async #handleRequest(apiCall) {
    try {
      const response = await apiCall
      return {
        success: true,
        data: response.data.data,
        status: response.status,
        message: response.data.message,
      }
    } catch (error) {
      return {
        success: false,
        error: error.response.data.message || error.message,
        status: error.response.status || 500,
      }
    }
  }

  getCart() {
    return this.#handleRequest(getCart())
  }

  getCartCount(config = {}) {
    return this.#handleRequest(getCartCount(config))
  }

  addCart(params) {
    return this.#handleRequest(addCart(params))
  }

  addCartByTransaction(transactionId) {
    return this.#handleRequest(addCartByTransaction(transactionId))
  }

  updateCart(cartId, params) {
    return this.#handleRequest(updateCart(cartId, params))
  }
}

const Cart = new HttpDataClient()
Object.freeze(Cart)

export default Cart
